import { render } from "./UpHeader.vue?vue&type=template&id=7a25e137&scoped=true"
import script from "./UpHeader.vue?vue&type=script&lang=js"
export * from "./UpHeader.vue?vue&type=script&lang=js"

import "./UpHeader.vue?vue&type=style&index=0&id=7a25e137&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7a25e137"

export default script